import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-privacy',
  templateUrl: './privacy.component.html',
  styleUrls: ['./privacy.component.css']
})
export class PrivacyComponent implements OnInit {

  currentLanguage: string;
  isMobileDevice: boolean = false;
  urlDoc5: SafeResourceUrl;

  constructor( public translate: TranslateService, private sanitizer: DomSanitizer ) { }

  ngOnInit(): void {
    this.currentLanguage = this.translate.currentLang === 'en' ? 'en' : 'es';
    const URL = `assets/documents/doc5_${this.currentLanguage}.pdf#toolbar=0&navpanes=0&scrollbar=0&zoom=page-width`;
    this.urlDoc5 = this.sanitizer.bypassSecurityTrustResourceUrl(URL);
    this.isMobileDevice = this.isMobile();
  }

  isMobile(): boolean {
    const userAgent = navigator.userAgent || navigator.vendor || (window as any).opera;
    const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
    return mobileRegex.test(userAgent);
  }

}
